import '../styles/css/main.less'

import animator from 'canvas-animator'
import Animation from './banner/Animation'
import * as global from './global'

export { initTypetext } from './banner/typetext'
export { initMobileMenu } from './mobile/menu'
export { initSlider } from './slider'
export { initAnchor } from './anchor'
export { fadeIn, fadeOut } from './fade'
export const initHeader = id => {
  const canvas = document.getElementById(id)
  if (canvas) {
    canvas.style.backgroundImage = 'url(https://s.lingxi360.com/lingxi/asset/home/1/banner.jpg)'
    canvas.style.backgroundPosition = 'center'
    canvas.style.backgroundSize = 'cover'

    let scale = 1
    let isMobile = false
    if (document.documentElement.clientWidth < 768) {
      isMobile = true
      const mobileScale = 1
      const targetHeight = 190
      const targetWidth = window.innerWidth
      canvas.style.width = `${targetWidth}px`
      canvas.style.height = `${targetHeight}px`
      scale = targetHeight / 845
      canvas.width = targetWidth / scale / mobileScale * global.scale
      canvas.height = targetHeight / scale / mobileScale * global.scale
    } else {
      let targetHeight = document.documentElement.clientHeight
      if (document.documentElement.clientHeight > 845) {
        targetHeight = document.documentElement.clientHeight - 150
      }
      canvas.style.height = `${targetHeight}px`
      scale = targetHeight / 845
      canvas.width = document.body.clientWidth / scale * global.scale
      canvas.height = targetHeight / scale * global.scale // 利用 width height 缩放
    }

    // 容器内水平居中
    const canvasContainer = canvas.parentElement
    if (canvasContainer) {
      canvas.style.top = '0'
      canvas.style.left = '50%'
      canvas.style.marginLeft = `${-canvas.offsetWidth / 2}px`

      canvasContainer.style.height = canvas.style.height
      // 超出 canvas 的部分显示背景不留白
      canvasContainer.style.backgroundImage = canvas.style.backgroundImage
      canvasContainer.style.backgroundPosition = canvas.style.backgroundPosition
      canvasContainer.style.backgroundSize = canvas.style.backgroundSize
    }

    const context = canvas.getContext('2d')
    const animation = new Animation(context, canvas.width / 2, canvas.height / 2, canvas.width, canvas.height)

    if (isMobile) {
      animation.title.scale = 2
      animation.title.y += 85
    }

    const myAnimator = new animator.Animator(animation)
    myAnimator.play()
    return {
      scale
    }
  } else {
    return null
  }
}
